// removed by extract-text-webpack-plugin
module.exports = {"cms-detail":"cms-detail","cms-content":"cms-content","cms-detail-title":"cms-detail-title","cms-detail-content":"cms-detail-content","news-detail-time":"news-detail-time"};


//////////////////
// WEBPACK FOOTER
// ./components/cms/cms.scss
// module id = ./components/cms/cms.scss
// module chunks = 0